export const theme = {
  colors: {
    primary: '#7c3aed',     // Purple (from RunPulse)
    primaryDark: '#6d28d9', // Darker purple for hover states
    secondary: '#ec4899',   // Pink for accents (from RunPulse)
    secondaryDark: '#db2777', // Darker pink for hover states
    dark: '#18181b',       // Zinc-900 for text
    light: '#fafafa',      // Light background
    gray: '#71717a',       // Medium gray for secondary text
    grayLight: '#e4e4e7',  // Light gray for borders
    grayDark: '#3f3f46',   // Dark gray for subtle elements
    danger: '#ef4444',     // Red for errors
    warning: '#f59e0b',    // Orange for warnings
    success: '#10b981',    // Green for success messages
    error: '#ef4444',      // Alias for danger (for consistency)
    lightGray: '#f4f4f5',   // Extra light gray for alternating rows
    background: {
      light: '#fafafa',    // Default light background
      card: '#ffffff',     // Card background
      accent: '#f5f3ff',   // Accent background (light purple)
      dark: '#18181b',     // Dark mode background
      gradient: 'linear-gradient(to bottom, rgba(124, 58, 237, 0.05) 0%, rgba(255, 255, 255, 0) 100%)',
    },
    gradient: {
      primary: 'linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)',
      secondary: 'linear-gradient(135deg, #ec4899 0%, #f472b6 100%)',
      cta: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)',
      text: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)',
    },
  },
  fonts: {
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    heading: "'Cal Sans', 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    mono: "'JetBrains Mono', 'SF Mono', 'Roboto Mono', Menlo, Consolas, monospace",
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem',
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  spacing: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    8: '2rem',
    10: '2.5rem',
    12: '3rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    32: '8rem',
    40: '10rem',
    48: '12rem',
    56: '14rem',
    64: '16rem',
  },
  shadows: {
    sm: '0 1px 3px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.04)',
    lg: '0 10px 25px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.03)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.03)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.04)',
    outline: '0 0 0 2px rgba(124, 58, 237, 0.4)',
    glow: '0 0 15px rgba(124, 58, 237, 0.5)',
    card: '0 1px 3px rgba(0, 0, 0, 0.02), 0 1px 2px rgba(0, 0, 0, 0.04)',
    none: 'none',
  },
  radii: {
    none: '0',
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    full: '9999px',
    pill: '9999px',
  },
  transitions: {
    default: 'all 0.2s ease-in-out',
    fast: 'all 0.1s ease-in-out',
    slow: 'all 0.3s ease-in-out',
  },
};

export type Theme = typeof theme;
export default theme;
